<template>
  <div>
    <fieldset>
      <legend class="text-blue ts-font-robot">
        {{ $t('promotionPackage.package') }}
        <Tooltip placement="top">
          <Icon type="ios-information-circle-outline" size="17" />
          <div slot="content">
            <div class="ts-text-xs">
              {{ $t('promotionPackage.package') }}
            </div>
          </div>
        </Tooltip>
      </legend>
      <div class="ts-space-y-3">
        <div v-if="model.package_list.length === 0" class="ts-flex ts-flex-col ts-items-center ts-justify-center ts-py-8 ts-text-gray-400">
          <Icon type="ios-gift-outline" size="40" />
          <span class="ts-mt-2 ts-text-sm">{{ $t('promotionPackage.noPackage') }}</span>
        </div>
        <div v-else v-for="(item, index) in model.package_list" :key="index">
          <ByProduct :item="item" :index="index" :validate="errors" @remove="model.package_list.splice(index, 1)" />
        </div>
        <div
          class="ts-w-full ts-border ts-border-dashed ts-border-blue-300 ts-rounded ts-py-1 ts-text-center ts-cursor-pointer ts-text-blue-500 hover:ts-border-blue-400 hover:ts-bg-blue-400 hover:ts-text-white ts-transition-colors"
          @click="addPackage">
          + {{ $t('promotionPackage.addPackage') }}
        </div>
      </div>
      <!-- <div class="overflow-auto ts-max-h-40">
        sad
        <ByProduct v-model="model" :validate="errors" />
      </div> -->
    </fieldset>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import ByProduct from './package-list.vue'
export default {
  name: 'promotionPackageCondition',
  props: ['value', 'validate'],
  components: {
    ByProduct,
  },
  data() {
    return {
      errors: new Errors(),
      show_apply_all: false,
      model: {},
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    ...mapState('promotion/promotionPackage', ['formViewDatas']),
  },
  methods: {
    addPackage() {
      let default_currency = null;
      if (this.formViewDatas['currency']) {
        default_currency = this.formViewDatas['currency'].find(el => el.is_default == true).currency_id
        // this.model.input_currency_id = this.currency_id
        // this.model.fx_rate = 1
        // this.model.fx_rate_ratio = 1
      }

      let newPackage = {
        package_id: null,
        package_name: null,
        currency_id: default_currency ? default_currency.currency_id : null,
        input_currency_id: default_currency ? default_currency.currency_id : null,
        fx_rate: default_currency ? default_currency.fx_rate : null,
        fx_rate_ratio: default_currency ? default_currency.fx_rate_ratio : null,
        sub_total: 0,
        input_sub_total: 0,
        discount_rate: 0,
        discount_type: '%',
        discount_amount: 0,
        input_discount_amount: 0,
        vat_rate: 0,
        vat_amount: 0,
        grand_total: 0,
        input_grand_total: 0,
        is_active: true,
        valid_from: true,
        valid_until: true,
        details: [],
      }
      this.model.package_list.push(newPackage)
    }
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    },
  },
}
</script>